import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, Leaf, Shield, Star } from 'lucide-react';
import { ConstellationCircle } from './Decorative';
import { useLanguage } from '../i18n/LanguageContext';
export function WorkshopExperience() {
  const {
    t
  } = useLanguage();
  const pillars = t('experience.pillars');
  const icons = [<Leaf className="w-8 h-8" data-id="element-882" />, <Shield className="w-8 h-8" data-id="element-883" />, <Star className="w-8 h-8" data-id="element-884" />];
  return <section className="py-24 md:py-32 px-6 bg-sage-lighter/20 relative overflow-hidden" data-id="element-885">
      <div className="absolute -left-64 bottom-0 w-[600px] h-[600px] text-sage-light/20 pointer-events-none" data-id="element-886">
        <ConstellationCircle data-id="element-887" />
      </div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-888">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 1
      }} className="text-center mb-20" data-id="element-889">
          <h2 className="text-4xl md:text-5xl font-serif text-forest-dark mb-6 italic" data-id="element-890">
            {t('experience.title')}
          </h2>
          <div className="w-16 h-[1px] bg-sage-dark mx-auto" data-id="element-891"></div>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8 mb-20" data-id="element-892">
          {pillars.map((pillar: string, index: number) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1 * index
        }} className="bg-white/80 backdrop-blur-sm rounded-[2rem] p-10 shadow-sm border border-sage-lighter/50 flex flex-col items-center text-center hover:shadow-soft transition-all duration-500" data-id="element-893">
              <div className="p-4 rounded-full bg-sage-lighter/30 text-sage-dark mb-6" data-id="element-894">
                {icons[index]}
              </div>
              <p className="text-xl font-serif text-forest-dark" data-id="element-895">{pillar}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="max-w-4xl mx-auto text-center space-y-10" data-id="element-896">
          <p className="text-xl text-forest/80 font-light leading-relaxed" data-id="element-897">
            {t('experience.p1')}
          </p>

          <div className="relative py-12" data-id="element-898">
            <div className="absolute inset-0 bg-gold rounded-[3rem] transform -skew-y-2 z-0 shadow-lg" data-id="element-899"></div>
            <div className="relative z-10 flex flex-col items-center justify-center gap-4 px-8" data-id="element-900">
              <Sparkles className="w-8 h-8 text-forest-dark mb-2" data-id="element-901" />
              <p className="text-2xl md:text-4xl font-serif text-forest-dark font-bold tracking-wide uppercase" data-id="element-902">
                {t('experience.highlight')}
              </p>
            </div>
          </div>

          <p className="text-xl text-forest/80 font-light leading-relaxed pt-8" data-id="element-903">
            {t('experience.p2')}
          </p>
        </motion.div>
      </div>
    </section>;
}